export function clearForm(state, payload) {
	return {
		...state,
		form: {},
	};
}

export function updateForm(state, payload) {
	return {
		...state,
		form: {
			...state.form,
			...payload,
		},
	};
}
export function updateCalculatedValues(state, payload) {
	return {
		...state,
		calculatedValues: {
			...payload,
		},
	};
}
export function updateClientDetails(state, payload) {
	return {
		...state,
		clientDetails: {
			...payload,
		},
	};
}
